import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import CreateUserInfoModel from '@/models/userInfos/createUserInfoModel';
import UpdatePasswordModel from '@/models/userInfos/updatePasswordModel';
import UpdateSelfInfoModel from '@/models/userInfos/updateSelfInfoModel';
import UpdateUserInfoModel from '@/models/userInfos/updateUserInfoModel';

export default class UserInfoService {
  /**
   * @description: 查询UserInfo信息
   * @page 页码
   * @size 每页大小
   * @searchValue 子账号过滤条件
   * @return {Promise}
   */
  static getAll = (page: number, size: number, searchValue?: string): Promise<IResponse> => {
    let url = `userinfo?page=${page}&size=${size}`;
    if (searchValue) url += `&search=${searchValue}`;
    return axiosInstance.get(url).then((res) => res.data);
  }

  /**
   * @description: 新增UserInfo信息
   * @params {CreateUserInfoModel} params
   * @return {Promise}
   */
  static create = (params: CreateUserInfoModel): Promise<IResponse> => axiosInstance.post('userinfo', params).then((res) => res.data);

  /**
   * @description: 查询指定UserInfo信息
   * @userId UserInfoId
   * @return {Promise}
   */
  static get = (userId: string): Promise<IResponse> => axiosInstance.get(`userinfo/${userId}`).then((res) => res.data);

  /**
   * @description: 修改指定UserInfo的密码
   * @userId UserInfo的Id
   * @return {Promise}
   */
  static updatePassword = (params: UpdatePasswordModel): Promise<IResponse> => axiosInstance.post('self/modifypassword', params).then((res) => res.data);

  /**
   * @description: 修改指定UserInfo的状态
   * @userId UserInfo的Id
   * @return {Promise}
   */
  static updateStatus = (userId: string, status: number): Promise<IResponse> => axiosInstance.put(`userinfo/updatestatus/${userId}`, { status }).then((res) => res.data);

  /**
   * @description: 重置指定UserInfo的密码
   * @userId UserInfo的Id
   * @return {Promise}
   */
  static resetPassword = (userId: string): Promise<IResponse> => axiosInstance.put(`userinfo/resetPassword/${userId}`).then((res) => res.data);

  /**
   * @description: 修改UserInfo的信息
   * @userId UserInfo的Id
   * @return {Promise}
   */
   static update = (userId: string, params:UpdateUserInfoModel): Promise<IResponse> => axiosInstance.put(`userinfo/${userId}`, params).then((res) => res.data);

   /**
    * @description: 修改个人信息
    * @params UpdateSelfInfoModel
    * @return {Promise}
    */
  static updateMyInfo = (params: UpdateSelfInfoModel): Promise<IResponse> => axiosInstance.post('self/updateuserinfo', params).then((res) => res.data);

  /**
    * @description: 查询个人信息
    * @return {Promise}
    */
  static getMyInfo(): Promise<IResponse> {
    return axiosInstance.get('self').then((res:any) => res.data);
  }
}
